// eslint-disable-next-line import/prefer-default-export
export function handleDownloadClick(attachmentUrl, fileName) {
  const response = window.confirm( // eslint-disable-line no-alert
    'While this file is encrypted during transmission, once downloaded, you are responsible for implementing appropriate safeguards to protect the data, including encryption or deletion to the extent required by applicable law.', // eslint-disable-line max-len
  );

  if (response === true) {
    const link = document.createElement('a');

    link.setAttribute('href', attachmentUrl);
    link.setAttribute('target', '_blank');
    link.setAttribute('download', fileName);

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
